<template>
  <div class="teaching-evaluate-apply"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="evaluations">
      <template v-if="evaluations.length">
        <div v-if="current"
             class="header">
          <div class="title">
            <div class="label">
              <el-dropdown class="evaluation"
                           trigger="click"
                           placement="bottom-start"
                           @command="onHandleChange">
                <div :class="['custom-trigger theme-text-active theme-light-bg-active theme-border-active', {'is-active': current.active}]">
                  <span>{{current.name}}</span>
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </div>
                <el-dropdown-menu class="teaching-evaluate-apply-select-popper"
                                  slot="dropdown">
                  <el-dropdown-item v-for="evaluation in evaluations"
                                    :key="evaluation.id"
                                    :class="['custom-item theme-text-active theme-light-bg-active', {'is-active': evaluation === current}]"
                                    :command="evaluation">
                    <span class="name">{{evaluation.name}}</span>
                    <span class="mark">
                        <i v-if="evaluation.active"
                           class="el-icon-place"></i>
                      </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="extra">
                <TeachingEvaluateApplyUpdate :evaluation="current">
                  <template #default="{toggleVisible}">
                    <el-button class="btn-update"
                               size="mini"
                               type="text"
                               icon="el-icon-edit"
                               :disabled="current.deleting"
                               @click="toggleVisible"></el-button>
                  </template>
                </TeachingEvaluateApplyUpdate>
                <el-divider direction="vertical"></el-divider>
                <el-button class="btn-delete"
                           size="mini"
                           type="text"
                           icon="el-icon-delete"
                           :disabled="current.deleting"
                           @click="onHandleDelete"></el-button>
              </div>
            </div>
            <div class="extra">
              <TeachingEvaluateApplyAdd @add-success="onAddSuccess">
                <template #default="{toggleVisible}">
                  <el-button size="mini"
                             type="text"
                             icon="el-icon-plus"
                             @click="toggleVisible">新增方案</el-button>
                </template>
              </TeachingEvaluateApplyAdd>
              <el-divider direction="vertical"></el-divider>
              <TeachingEvaluateApplySwitch :evaluations="evaluations"
                                           @switch-success="loadEvaluations">
                <template #default="{toggleVisible}">
                  <el-button size="mini"
                             type="text"
                             icon="el-icon-refresh"
                             @click="toggleVisible">切换方案</el-button>
                </template>
              </TeachingEvaluateApplySwitch>
            </div>
          </div>
          <div v-if="current.remark"
               class="append">{{current.remark}}</div>
        </div>
        <div class="main">
          <div class="main-cont">
            <template v-if="current">
              <TeachingEvaluateApplyMain :key="current.id"
                                         :evaluation="current"></TeachingEvaluateApplyMain>
            </template>
            <template v-else>
              <Hint>
                <span>请先选择方案</span>
              </Hint>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="empty-tip">
          <div class="icon">
            <i class="el-icon-warning-outline"></i>
          </div>
          <div class="text">暂无评教方案</div>
          <div class="btn-group">
            <TeachingEvaluateApplyAdd @add-success="onAddSuccess">
              <template #default="{toggleVisible}">
                <el-button size="medium"
                           type="primary"
                           plain
                           @click="toggleVisible">添加评教方案</el-button>
              </template>
            </TeachingEvaluateApplyAdd>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>评教方案数据加载失败</div>
        <el-button type="text"
                   @click="loadEvaluations">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import TeachingEvaluateApplyAdd from './add'
import TeachingEvaluateApplyUpdate from './update'
import TeachingEvaluateApplySwitch from './switch'
import TeachingEvaluateApplyMain from './main'
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'TeachingEvaluateApply',
  components: {
    TeachingEvaluateApplyAdd,
    TeachingEvaluateApplyUpdate,
    TeachingEvaluateApplySwitch,
    TeachingEvaluateApplyMain,
    Hint
  },
  data () {
    return {
      loading: false,
      evaluations: null,
      current: ''
    }
  },
  methods: {
    loadEvaluations () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/evaluations',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.evaluations = response.data['evaluations'] || []
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    onHandleChange (evaluation) {
      this.current = evaluation
    },
    onAddSuccess (evaluation) {
      if (this.evaluations) {
        this.evaluations.unshift(evaluation)
      } else {
        this.loadEvaluations()
      }
    },
    onHandleDelete () {
      const current = this.current
      if (current) {
        this.$confirm(`确定要删除“${current.name}”方案吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$set(current, 'deleting', true)
          this.$ajax({
            url: '/workspace/manager/teaching/evaluate/apply/plan/delete',
            method: 'post',
            data: this.$qs.stringify({
              id: current.id
            })
          }).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  let evaluations = this.evaluations
                  if (evaluations) {
                    let index = evaluations.findIndex(item => item.id === current.id)
                    if (index >= 0) {
                      evaluations.splice(index, 1)
                    }
                  }
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.$delete(current, 'deleting')
          })
        }).catch(() => {})
      }
    }
  },
  mounted () {
    this.loadEvaluations()
  },
  watch: {
    evaluations (val) {
      let evaluations = val || []
      if (this.current) {
        let getCurrent = evaluations.find(item => item.id === this.current.id)
        if (getCurrent) {
          this.current = getCurrent
          return
        }
      }
      if (evaluations.length) {
        let getActive = evaluations.find(evaluation => evaluation.active)
        if (getActive) {
          this.current = getActive
        } else {
          this.current = evaluations[0]
        }
      } else {
        this.current = null
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../styles/color";
  .teaching-evaluate-apply {
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      border-bottom: 1px solid #ebeef5;
      padding: 12px 15px;
      & > .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        & > .label {
          display: flex;
          align-items: center;
          & > .evaluation {
            .custom-trigger {
              min-width: 160px;
              color: #606266;
              font-size: 12px;
              font-weight: bold;
              background-color: #ebeef5;
              padding: 5px 6px 5px 10px;
              border-left: 3px solid #606266;
              border-radius: 0 20px 20px 0;
              cursor: pointer;
              transition: all .3s;
              display: flex;
              justify-content: space-between;
              align-items: center;
              i {
                font-size: 14px;
              }
              &:hover {
                color: #303133;
                background-color: #dcdfe6;
              }
            }
          }
          & > .extra {
            margin-left: 15px;
            .el-button {
              &.btn-update {
                color: $set-info-color;
              }
              &.btn-delete {
                color: $set-danger-color;
              }
            }
          }
        }
        & > .extra {
          margin-left: 10px;
        }
      }
      & > .append {
        margin-top: 10px;
        color: #909399;
        font-size: 12px;
        white-space: pre-wrap;
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
    .empty-tip {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      & > .icon {
        i {
          color: $set-warning-color;
          font-size: 46px;
        }
      }
      & > .text {
        margin-top: 15px;
        font-size: 16px;
        font-weight: bold;
      }
      & > .btn-group {
        margin-top: 25px;
        .el-button {
          border-radius: 0;
        }
      }
    }
  }
  .teaching-evaluate-apply-select-popper {
    margin-top: 5px!important;
    .popper__arrow {
      display: none!important;
    }
    .custom-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-width: 180px;
      font-size: 12px!important;
      padding: 2px 12px!important;
      & > .name {
        font-weight: bold;
      }
      & > .mark {
        margin-left: 20px;
      }
    }
  }
</style>
